import { render } from "./AnnexAlarmAcknowledge.vue?vue&type=template&id=6dccb231&ts=true"
import script from "./AnnexAlarmAcknowledge.vue?vue&type=script&lang=ts"
export * from "./AnnexAlarmAcknowledge.vue?vue&type=script&lang=ts"

import "./AnnexAlarmAcknowledge.vue?vue&type=style&index=0&id=6dccb231&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__